module.exports = __webpack_public_path__ + "img/home-13.c6a196fe.png";